import { Box, IconButton, Modal, TextField } from '@mui/material';
import styles from './EditOfficeDetailsModal.module.css';
import { GetOffice_Out, OfficesService } from 'src/pehra-ts-client';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LoadingButton } from '@mui/lab';

export interface IEditOfficeDetailsModal {
  openModal: boolean;
  handleCloseModal: () => void;
  officeDetail: GetOffice_Out | undefined;
}

const EditOfficeDetailsModal: React.FC<IEditOfficeDetailsModal> = ({ openModal, handleCloseModal, officeDetail }) => {
  const [officeName, setOfficeName] = useState<string>(officeDetail?.office_name || '');

  const queryClient = useQueryClient();

  const updateOfficeDetails = async () => {
    try {
      const res = await OfficesService.updateOffice(officeDetail?.id as string, {
        office_name: officeName,
        state: officeDetail?.state as any,
        parent_office_id: officeDetail?.parent_office_id || null
      });
      return res;
    } catch (error) {
      throw error;
    }
  };

  const updateOfficeDetailsMutation = useMutation({
    mutationFn: updateOfficeDetails,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['office', officeDetail?.id || null]
      });
      queryClient.invalidateQueries({
        queryKey: ['officeTree']
      });
      handleCloseModal();
    }
  });

  useEffect(() => {
    setOfficeName(officeDetail?.office_name || '');
  }, [officeDetail]);

  return (
    <Modal open={openModal} onClose={handleCloseModal}>
      <Box className={styles.modalContainer}>
        <IconButton onClick={handleCloseModal} style={{ position: 'absolute', right: '10px', top: '10px' }}>
          <CloseIcon />
        </IconButton>
        <Box
          sx={{
            marginTop: '50px'
          }}
        >
          <Box className={styles.modalTitle}>Edit Office Details</Box>

          <TextField
            label="Office Name"
            variant="outlined"
            value={officeName}
            onChange={(e) => {
              setOfficeName(e.target.value);
            }}
            fullWidth
            sx={{
              marginTop: '20px',
              marginBottom: '20px'
            }}
          />

          <LoadingButton
            loading={updateOfficeDetailsMutation.isPending}
            onClick={() => {
              updateOfficeDetailsMutation.mutate();
            }}
            variant="contained"
            fullWidth
          >
            Save
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditOfficeDetailsModal;
